import React, { useState } from 'react';
import styled from 'styled-components';

import pictureIcon from 'assets/windowsIcons/307(32x32).png';
import folderIcon from 'assets/windowsIcons/318(16x16).png';
import eightBitVersion from 'assets/images/8bitVersion.webp';
import angle from 'assets/images/angle.webp';
import building from 'assets/images/building.webp';
import chain from 'assets/images/chain.webp';
import cruel from 'assets/images/cruel.webp';
import cubes from 'assets/images/cubes.webp';
import early from 'assets/images/early.webp';
import gharib from 'assets/images/gharib.webp';
import green from 'assets/images/green.webp';
import jesus from 'assets/images/jesus.webp';
import spine from 'assets/images/spine.webp';
import statue from 'assets/images/statue.webp';
import waco from 'assets/images/waco.webp';
import wings from 'assets/images/wings.webp';

const images = [
  { name: '8bitVersion.webp', src: eightBitVersion },
  { name: 'angle.webp', src: angle },
  { name: 'building.webp', src: building },
  { name: 'chain.webp', src: chain },
  { name: 'cruel.webp', src: cruel },
  { name: 'cubes.webp', src: cubes },
  { name: 'early.webp', src: early },
  { name: 'gharib.webp', src: gharib },
  { name: 'green.webp', src: green },
  { name: 'jesus.webp', src: jesus },
  { name: 'spine.webp', src: spine },
  { name: 'statue.webp', src: statue },
  { name: 'waco.webp', src: waco },
  { name: 'wings.webp', src: wings },
];

function MyPictures() {
  const [selectedImage, setSelectedImage] = useState(images[0]);

  return (
    <Div>
      <div className="pictures__toolbar">
        <span>File</span>
        <span>Edit</span>
        <span>View</span>
        <span>Favorites</span>
        <span>Tools</span>
        <span>Help</span>
      </div>
      <div className="pictures__address">
        <span>Address</span>
        <div className="pictures__address-path">
          <img src={folderIcon} alt="" />
          My Pictures
        </div>
      </div>
      <div className="pictures__content">
        <div className="pictures__grid" aria-label="Image thumbnails">
          {images.map(image => (
            <button
              key={image.name}
              type="button"
              className={`pictures__thumb${
                selectedImage.name === image.name ? ' is-selected' : ''
              }`}
              onClick={() => setSelectedImage(image)}
            >
              <img src={image.src} alt={image.name} />
              <span>{image.name}</span>
            </button>
          ))}
        </div>
        <div className="pictures__preview">
          <div className="pictures__preview-frame">
            <img src={selectedImage.src} alt={selectedImage.name} />
          </div>
          <div className="pictures__preview-name">
            <img src={pictureIcon} alt="" />
            <span>{selectedImage.name}</span>
          </div>
        </div>
      </div>
    </Div>
  );
}

const Div = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: Tahoma, 'Noto Sans', sans-serif;
  font-size: 11px;
  color: #111;
  background: #ece9d8;
  border-left: 1px solid #0831d9;
  border-right: 1px solid #0831d9;
  border-bottom: 1px solid #0831d9;

  .pictures__toolbar {
    height: 23px;
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 0 8px;
    background: #ece9d8;
    border-bottom: 1px solid #d8d2bd;
    flex-shrink: 0;
  }

  .pictures__address {
    height: 28px;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 3px 6px;
    color: #6b6b6b;
    background: #ece9d8;
    border-top: 1px solid #fff;
    border-bottom: 1px solid #aca899;
    flex-shrink: 0;
  }

  .pictures__address-path {
    height: 20px;
    min-width: 0;
    flex: 1;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 1px 4px;
    color: #111;
    background: #fff;
    border: 1px solid #7f9db9;
  }

  .pictures__address-path img {
    width: 16px;
    height: 16px;
  }

  .pictures__content {
    min-height: 0;
    flex: 1;
    display: grid;
    grid-template-columns: minmax(220px, 1fr) minmax(190px, 240px);
    background: #fff;
  }

  .pictures__grid {
    min-height: 0;
    display: flex;
    align-content: flex-start;
    gap: 12px 14px;
    flex-wrap: wrap;
    padding: 14px;
    overflow: auto;
  }

  .pictures__thumb {
    width: 78px;
    min-height: 86px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    padding: 4px;
    border: 1px solid transparent;
    background: transparent;
    color: #111;
    font-family: inherit;
    font-size: 11px;
  }

  .pictures__thumb:hover,
  .pictures__thumb.is-selected {
    border-color: #7da2ce;
    background: #edf4ff;
  }

  .pictures__thumb img {
    width: 56px;
    height: 56px;
    object-fit: cover;
    border: 1px solid #b8b8b8;
    background: #fff;
  }

  .pictures__thumb span {
    width: 100%;
    line-height: 13px;
    overflow-wrap: anywhere;
    text-align: center;
  }

  .pictures__preview {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 12px;
    background: #f1f5fb;
    border-left: 1px solid #c7d8ee;
  }

  .pictures__preview-frame {
    min-height: 0;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    background: #fff;
    border: 1px solid #9eb6d8;
  }

  .pictures__preview-frame img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  .pictures__preview-name {
    min-height: 24px;
    display: flex;
    align-items: center;
    gap: 6px;
    color: #00136b;
    font-weight: 700;
  }

  .pictures__preview-name img {
    width: 20px;
    height: 20px;
  }

  @media (max-width: 560px) {
    .pictures__content {
      grid-template-columns: 1fr;
    }

    .pictures__preview {
      min-height: 180px;
      border-left: 0;
      border-top: 1px solid #c7d8ee;
    }
  }
`;

export default MyPictures;
